import { capitalize } from "lodash";
import { RuleData } from "./RuleEditor";
import { IConfig, IStructuredError } from "store/types";

export const getBlankRule = (rid: number) => {
  return {
    checked: false,
    rid,
    rule: "",
    type: "",
    sourceMatchScript: "",
    action: "",
    targetMatchScript: "",
  };
};

export const isLatestVersion = (config: IConfig, version: string): boolean => {
  if (config && config.versions) {
    return Math.max(...config.versions.map((v) => v.version)) === Number(version);
  }
  return false;
};

export const prepareRulesForDisplay = (rules: RuleData[]) => {
  rules.forEach((rule) => {
    rule.checked = false;
    rule.type = capitalize(rule.type.toLowerCase());
    rule.action = capitalize(rule.action.toLowerCase());
    rule.rule = "Custom";
  });
  return rules.sort((r1, r2) => r1.rid - r2.rid);
};

export const prepareRulesForUpload = (rules: RuleData[]) => {
  rules.forEach((rule, i) => {
    // resynch the rid - must start at 1
    rule.rid = i + 1;
    rule.action = rule.action.toUpperCase();
  });
  return rules;
};

export const validateRules = (rules: RuleData[]) => {
  const errors = <IStructuredError[]>[];
  rules.forEach((rule, i) => {
    if (rule.type === "" || rule.action === "" || rule.sourceMatchScript === "") {
      errors.push({ line: i, error: "Invalid rule definition", rid: rule.rid });
    }
  });
  return errors;
};

export const createCsvData = (rules: RuleData[]) => {
  const newRules = prepareRulesForUpload(rules);
  let csvData = "id,sourceMatchScript,targetMatchScript,action,type\n";
  newRules.forEach((rule) => {
    csvData += `${rule.rid},"${rule.sourceMatchScript.replaceAll('"', '""')}","${rule.targetMatchScript.replaceAll(
      '"',
      '""',
    )}",${rule.action},${rule.type}\n`;
  });
  return csvData;
};
